import { nb, sv } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import type { ElasticOdometerReading } from '../@types/ElasticVehicle';
import { numberSeparator } from '../helpers/formats';
import { getMarket } from '../i18n';

const hiddenFiltersPerMarket: Record<string, string[]> = {
  NO: ['mileage', 'fuelType'],
  SE: ['odometerValueAsKm', 'fuelType'],
};

export const getStaticMarketPath = () => (getMarket().marketCode === 'NO' ? 'drive' : 'wayke');

export const getDateFnsLocale = () => (getMarket().marketCode === 'NO' ? nb : sv);

export const getAutomotiveAssociationName = () => (getMarket().marketCode === 'NO' ? 'nbf' : 'mrf');

export const getConvertedMileageValue = (mileage: number) =>
  getMarket().marketCode === 'NO' ? mileage * 10 : mileage;

export const getConvertedMileage = (mileage: number) => {
  const { t } = useTranslation(['glossary']);
  const market = getMarket().marketCode;
  const calculatedMilage = market === 'NO' ? mileage * 10 : mileage;

  return `${numberSeparator(calculatedMilage)} ${t('mileageUnit', {
    ns: 'glossary',
    count: mileage,
  }).toLowerCase()}`;
};

// Return correct odometer value and unit based on market
export const getMarketOdometer = (odometerReading: ElasticOdometerReading) => {
  const { t } = useTranslation(['glossary']);
  const market = getMarket().marketCode;
  let marketOdometer = odometerReading.value;

  if (market === 'NO' && odometerReading.unit === 'mil') {
    marketOdometer = odometerReading.value * 10;
  } else if (market === 'SE' && odometerReading.unit === 'km') {
    marketOdometer = odometerReading.value / 10;
  }

  return `${numberSeparator(marketOdometer)} ${t('mileageUnit', {
    ns: 'glossary',
    count: 2,
  }).toLowerCase()}`;
};

export const getHiddenFilters = () => hiddenFiltersPerMarket[getMarket().marketCode] ?? [];
